<template>
  <div id="app-wrapper">
    <header id="desktop-header">
      <div>
        <h1 class="font-bold text-xl">
          <router-link to="/">Kaado.</router-link>
        </h1>
        <nav v-if="hasIntro">
          <router-link
            to="/queue"
            class="button button-primary small-button"
            id="lefts-go"
            >Let's Go!</router-link
          >
          <span v-if="user"> | </span>
          <router-link to="/float" v-if="user"> Float</router-link>
          <span v-if="user"> | </span>
          <router-link to="/connect" v-if="user">Connect</router-link>
          <span v-if="user"> | </span>
          <router-link to="/dashboard" v-if="user">My Library</router-link>
          <span v-if="user"> | </span>
          <router-link to="/tags" v-if="user">Tags</router-link>
          <span v-if="user"> | </span>
          <router-link to="/discover" v-if="user">Discover</router-link>
          |
          <router-link to="/pricing">Pricing</router-link>
          |
          <router-link to="/contact">Contact</router-link>
        </nav>
      </div>
      <div id="user-wrapper">
        <!-- display the name of the currentUser or 'not logged in' -->
        <div id="user-info" v-if="user">
          <div>
            <svg
              class="w-6 h-6 icon"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
              ></path>
            </svg>
            <span>
              <router-link to="/profile">
                {{ user.email }}
              </router-link>
            </span>
          </div>
          <button @click.prevent="signOut" class="button-as-link">
            Logout
          </button>
        </div>

        <router-link to="/login" class="button" id="login" v-else
          >Log in</router-link
        >
      </div>
    </header>

    <header id="mobile-header" v-if="user">
      <router-link class="mobile-nav-link" to="/queue">
        <svg
          class="icon mobile-icon"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
          ></path>
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          ></path>
        </svg>
        <span> Let's Go </span>
      </router-link>
      <router-link class="mobile-nav-link" to="/dashboard">
        <svg
          class="icon mobile-icon"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
          ></path>
        </svg>
        <span> My Collections </span>
      </router-link>

      <router-link class="mobile-nav-link" to="/profile">
        <svg
          class="icon mobile-icon"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
          ></path>
        </svg>
        <span>Profile</span>
      </router-link>
    </header>
    <header id="mobile-header" v-else>
      <router-link to="/"
        ><h1 class="font-bold text-xl">Kaado.</h1>
      </router-link>

      <div class="mobile-header-nav">
        <router-link class="mobile-nav-link" to="/login">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="icon mobile-icon"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"
            />
          </svg>
          <span>Login</span>
        </router-link>

        <router-link class="mobile-nav-link" to="/register">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="icon mobile-icon"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <span>Register</span>
        </router-link>
      </div>
    </header>

    <div id="score-wrapper" v-if="user && hasIntro">
      <div
        id="score"
        :style="{ 'max-width': level.levelPercentage + '%' }"
      ></div>
      <div id="score-info">
        <span class="info-wrapper">
          <h6>XP:</h6>
          {{ score }}</span
        >
        <span class="info-wrapper"
          ><h6>Level:</h6>
          {{ level.currentLevel }}
        </span>
      </div>
    </div>

    <div id="set-password" v-if="$store.state.isPasswordReset">
      <div class="wrapper" id="pricing-wrapper">
        <div class="card">
          <h2>Please set your new password</h2>

          <div class="input-group">
            <label for="password">Password</label>
            <input
              class="input"
              type="password"
              id="password"
              v-model="form.password"
              required
            />
          </div>
          <div class="input-group">
            <label for="password">Confirm Password</label>
            <input
              class="input"
              type="password"
              id="password-conf"
              v-model="form.passwordConf"
              required
            />
          </div>
          <button
            class="button button-primary button-right"
            @click="setPassword"
          >
            Set New Password
          </button>
        </div>

        <br />
      </div>
    </div>
    <div v-else class="meta-wrapper">
      <Intro v-if="!hasIntro" />

      <main v-else>
        <router-view />
      </main>
    </div>
  </div>

  <component
    is="script"
    data-goatcounter="https://kaado-3353450qe3232.goatcounter.com/count"
    async
    src="//gc.zgo.at/count.js"
  ></component>
</template>
<script>
import { useStore } from "vuex";
import { computed, onMounted, ref } from "vue";
import router from "./router";

import { supabase } from "./supabase";
import Intro from "./components/Intro.vue";
import Toastify from "toastify-js";
import "toastify-js/src/toastify.css";

export default {
  name: "App",
  components: { Intro },
  el: "#app",
  data() {
    return {
      form: {},
    };
  },
  setup() {
    const store = useStore();

    const signOut = () => {
      // dispatch the sign out action to log user out
      store.dispatch("signOutAction");
    };

    // we initially verify if a user is logged in with Supabase
    store.state.user = supabase.auth.user();
    // we then set up a listener to update the store when the user changes either by logging in or out
    supabase.auth.onAuthStateChange((event, session) => {
      
      if (event == "PASSWORD_RECOVERY") {
        

        store.state.isPasswordReset = true;
      }
      if (event == "SIGNED_OUT") {
        store.state.user = null;
      } else {
        store.state.user = session.user;
        store.dispatch("getUserProfile").then(() => {
          store.dispatch("getUserScore");
        });
      }
    });

    store.dispatch("loadTags");

    return {
      store,
      signOut,
    };
  },

  computed: {
    user() {
      return this.store.state.user;
    },
    level() {
      // the level function is 50x^2 - 50x = y
      // where x is the level and y is the current score
      // for a given score, calculate the level
      let y = 0;
      y = this.score;

      // calculate x for the function with pq
      // x^2 + (-1x) + (-y/50)
      const x = 0.5 + Math.sqrt(0.25 + y / 50.0);
      const currentLevel = Math.floor(x);
      const lowerLimit = 50 * Math.pow(currentLevel, 2) - 50 * currentLevel;
      const upperLimit =
        50 * Math.pow(currentLevel + 1, 2) - 50 * currentLevel + 1;
      const levelPercentage =
        ((y - lowerLimit) / (upperLimit - lowerLimit)) * 100;
      return {
        currentLevel,
        levelPercentage,
      };
    },
    score() {
      if (this.$store.state.profile) {
        return this.$store.state.profile.score;
      }
      return 0;
    },
    hasIntro() {
      if (this.$store.state.profile) {
        return this.$store.state.profile.has_intro;
      }
      return true;
    },
  },

  methods: {
    async setPassword() {
      try {
        if (this.form.password !== this.form.passwordConf) {
          throw "Passwords don't match";
        }
        const { error, data } = await supabase.auth.update({
          password: this.form.password,
        });

        if (error) {
          throw error;
        }
        this.$store.state.isPasswordReset = false;
      } catch (error) {
        
        Toastify({
          text: "Setting Password failed. Please try again. \n" + error,
          duration: 3000,
          newWindow: true,
          close: true,
          gravity: "top", // `top` or `bottom`
          position: "center", // `left`, `center` or `right`
          stopOnFocus: true, // Prevents dismissing of toast on hover
          style: {
            background: "var(--primary-500)",
          },
          onClick: function () {}, // Callback after click
        }).showToast();
      }
    },
  },
};
</script>
<style>
@tailwind base;
@tailwind components;
@tailwind utilities;
</style>

<style>
@import url('<link rel="preconnect" href="https://fonts.googleapis.com"');
@import url("https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;1,400;1,500;1,700&display=swap");

:root {
  --primary-100: #fcf2e9;
  --primary-200: #f9e2c7;
  --primary-300: #f5d8a4;
  --primary-400: #eeb867;
  --primary-500: #f77546;
  --primary-600: #d14a2f;
  --primary-700: #b1241d;
  --primary-800: #8b1c0b;
  --primary-900: #5d0a02;

  --neutral-900: #21252a;
  --neutral-800: #2d3740;
  --neutral-700: #3a4e5b;
  --neutral-600: #4b5f6c;
  --neutral-500: #5f6c7c;
  --neutral-400: #818a96;
  --neutral-300: #d6d9dd;
  --neutral-200: #e7e7e7;
  --neutral-100: #fafafa;

  --positive-900: #053f33;
  --positive-700: #09866d;
  --positive-500: #00d0ad;
  --positive-300: #65e9ce;
  --positive-100: #9ef5e3;

  --danger-900: #4a0a00;
  --danger-700: #8b1c0b;
  --danger-500: #d14a2f;
  --danger-300: #f77546;
  --danger-100: #f8baba;
}

html,
body,
div,
header,
footer,
section,
article,
aside,
nav,
h1,
h2,
h3,
h4,
h5,
h6,
p,
ul,
li,
button,
a,
img,
.wrapper,
main {
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  vertical-align: baseline;
  background: transparent;
  box-sizing: border-box;
  font-family: "Poppins", sans-serif;
}

body,
html,
#app {
  height: 100%;
}

#app-wrapper,
body,
html,
#app {
  display: flex;
  flex-direction: column;
}

body,
#app,
#app-wrapper,
main,
.wrapper {
  flex: 1;
}

main {
  padding-top: 124px;
}

#app-wrapper,
#app {
  max-height: 100vh;
}

.wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.meta-wrapper {
  flex: 1;
  display: flex;
}

html {
  background: var(--neutral-100);
  color: var(--neutral-800);
  font-family: "Poppins", sans-serif;
}

a {
  color: var(--neutral-800);
  text-decoration: none;
  transition: 0.2s;
}

.router-link-active {
  font-weight: 700;
  color: black !important;
}

ul,
ol {
  margin: 12px inherit;
}

.card a {
  text-decoration: underline 3px var(--neutral-500) dotted;
}

.inner-queue-card a {
  color: var(--neutral-600);
}

progress {
  margin-left: 8px;
}

progress::-moz-progress-bar {
  background: var(--primary-500);
}
progress::-webkit-progress-value {
  background: var(--primary-500);
}
progress {
  color: var(--primary-500);
}

.button-as-link {
  color: var(--neutral-900);
  transition: 0.2s;
  cursor: pointer;
}

a:hover,
.button-as-link:hover {
  color: var(--primary-400);
}

header {
  background: rgba(232, 232, 232, 0.95);
  padding: 8px 16px 16px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 999;
}

footer {
  display: flex;
  justify-content: center;
  gap: 16px;
}

#mobile-header {
  display: none;
}

.flex {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.flex-center {
  display: flex;
  gap: 16px;
  align-items: center;
}

blockquote {
  border-left: 8px solid var(--neutral-300);
  text-align: left;
  padding-left: 32px;
}

pre {
  text-align: left;
  background: var(--neutral-300);
  padding: 24px;
  border-radius: 12px;
}

code {
  background: var(--neutral-300);
  padding: 4px 8px;
  border-radius: 12px;
}

pre code {
  padding: 0;
  border-radius: 0;
}

.flex-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

@media (max-width: 600px) {
  #desktop-header {
    display: none;
  }

  #mobile-header {
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 12px 16px;
    background: var(--neutral-200);
  }

  .mobile-nav-link {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 8pt;
  }

  .mobile-header-nav {
    display: flex;
    gap: 16px;
  }

  h1 {
    font-size: 18pt;
    padding: 0;
    margin: 0;
  }
}

main {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.small {
  font-size: 10px;
}

.center {
  margin: auto;
  text-align: center;
}

.w-full {
  width: 90%;
}

.single-center {
  display: grid;
  place-items: center;
}
.alert {
  color: var(--danger-500);
}

.card {
  padding: 32px;
  border-radius: 24px;
  margin: 8px;
  background: var(--neutral-200);
  animation: popup 0.1s ease-in-out;
}

.small-card {
  width: min(95%, 700px);
  margin: 0 auto;
  border: 3px var(--neutral-300) solid;
}
#preview-cards-wrapper {
  margin-top: 32px;
}

#preview-cards {
  display: flex;
}

#rest-counter {
  margin: auto 8px;
}
.mini-card {
  background: var(--neutral-100);
  font-size: 7px;
  margin: 6px 0 0 -18px;
  padding: 6px;
  border-radius: 6px;
  box-shadow: 0px 0px 8px var(--neutral-300);
  width: 50px;
  max-width: 50px;
  overflow: hidden;
  max-height: 90px;
  height: 90px;
  opacity: 0.9;
  transition: 0.3s;
}
.mini-card:hover {
  opacity: 1;
  color: var(--neutral-900);
  cursor: pointer;
  z-index: 200;
}

.firstCard {
  margin-left: 0;
}

.solo-card {
  margin-top: 18px;
}

.intro-card > * {
  margin: 12px 0;
}

.button-right {
  float: right;
}

@keyframes popup {
  0% {
    transform: scale(0.9);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes hide-1-sec {
  0% {
    transform: scale(0.9);
  }
  100% {
    transform: scale(1);
  }
}

.hide-1-sec {
  animation: hide-1-sec 0.2s ease-in-out;
  animation-delay: 2s;
  transform: scale(0);
}

.button-list {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin: 16px 0;
}

.button {
  background: var(--neutral-300);
  border-radius: 24px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: bold;
  color: var(--neutral-700);
  cursor: pointer;
  transition: 0.3s;
}

.small-button {
  padding: 8px 16px;
  font-size: 12px;
  border-radius: 12px;
}

.button:enabled:hover {
  background: var(--neutral-400);
  color: var(--neutral-100);
}

.button-primary {
  background: var(--primary-500);
  color: var(--neutral-100);
}

.icon {
  height: 24px;
  width: 24px;
  cursor: pointer;
}

.icon-grey {
  opacity: 0.3;
  cursor: default;
}

.icon-small {
  height: 16px;
  width: 16px;
  opacity: 0.7;
  cursor: pointer;
}

.icon-small:hover {
  filter: brightness(150%);
}

#user-wrapper {
  display: flex;
  gap: 12px;
  align-items: center;
}

#login {
  margin-top: 12px;
}

.input-group {
  display: flex;
  flex-direction: column;
  margin: 16px 0;
}

input,
textarea,
select {
  margin: 8px 0;

  border-radius: 24px;
  padding: 16px;
  color: var(--neutral-900);
  background: var(--neutral-100);
  border: none;
}

select {
  border-radius: 12px;
}

input[type="file"] {
  padding: 0;
  background: none;
  border-radius: none;
  margin: none;
}

.big-icon {
  max-width: 100px;
  max-height: 100px;
}

.align-left {
  text-align: left;
}

/* COLLECTIONS  */

#collections-wrapper {
  display: grid;
  grid-template-columns: 1fr 3fr;
  padding: 16px;
  padding-top: 0;
  margin-top: 0;
  gap: 16px;
}

#collections-list {
  list-style-type: none;
  margin: 0;
  padding: 0;
  overflow-y: auto;
  max-height: 75vh;
}

#collections-overview {
  position: relative;
}

#collections-heading {
  margin-left: 8px;
  margin-bottom: 16px;
}

#collections {
  padding: 16px;
  position: relative;
}
.collection {
  cursor: pointer;
  transition: 0.2s;
  margin: 4px;
  padding: 4px 16px;
  border-radius: 8px;
  height: 100%;
}

#edit-cards-wrapper {
  margin-top: 12px;
}
.activeCollection {
  background: var(--neutral-100);
}

#collection-card {
  margin: 0;
}

.my-collection:hover {
  color: var(--neutral-700);
  background: var(--neutral-300);
}

.disabled {
  opacity: 0.6;
}

.emoji-picker__wrapper {
  z-index: 3;
}

#emoji-trigger {
  padding: 16px;
  font-size: 48px;
  line-height: 48px;
  margin-top: 0;
  cursor: pointer;
}
.emoji-picker__wrapper {
  position: fixed;
  left: 5vh;
  top: 5vh;
}

#top-row {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
}
/* COLLECTION */

#edit {
  display: flex;
  flex-direction: column;
  flex: 1;
}

#edit-card {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.big-input {
  max-width: 500px;
  font-size: 32px;
  margin-top: 0;
}

#card-heading-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

.card-heading {
  flex-grow: 1;
}

#edit-grid {
  display: flex;
  gap: 8px;
  margin: 8px;
  flex: 1;
  max-height: 100%;
  height: 100%;
}

#sidebar {
  height: 100%;
  display: flex;
  gap: 8px;
  flex-direction: column;
  position: relative;
  min-width: 420px;
}

#limited-sidebar {
  max-height: 80vh;
  overflow-y: auto;
  position: relative;
}

#collection-settings {
  position: relative;
  flex: 1;
}

#card-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-y: auto;
  max-height: 90%;
}

.card-list-card {
  background: var(--neutral-100);
  padding: 8px 16px;
  border-radius: 16px;
  display: inline-block;
  text-align: left;
  color: var(--neutral-800);
}

.card-list-card:hover {
  background: var(--neutral-300);
  cursor: pointer;
}

.flex-list {
  display: flex;
  flex-direction: column;
}

.search-result {
  border: 2px solid var(--neutral-200);
  margin: 8px;
}

.active {
  border: 3px var(--primary-400) solid;
  color: var(--neutral-900);
}

#description {
  margin-top: 8px;
  width: 400px;
}

.card-content {
  width: 100%;
  margin-right: 32px;
  box-sizing: border-box;
  flex: 1;
  font-size: 1.3em;
  line-height: 1.5em;
}

#public-wrapper {
  margin: 8px 0;
  display: flex;
  gap: 8px;
  align-items: center;
}

#danger-zone-wrapper {
  margin-left: 3px;
}

#danger-zone-sum {
  color: var(--danger-700);
}

#delete-collection {
  margin: 8px 0;
}

#danger-zone > div {
  margin-left: 16px;
}

#type-info {
  font-size: 10pt;
}

#save-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

#new-card {
  color: var(--primary-500);
  fill: var(--neutral-100);
  width: 90px;
  height: 90px;
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1000;
}

#search {
  width: 100%;
  margin: 12px auto;
  box-sizing: border-box;
}

input[type="checkbox"] {
  margin-right: 8px;
}

.extra-selector {
  border-top: 1px solid grey;
  margin: 8px 0;
  padding-top: 18px;
}

#interval {
  padding: 4px;
  width: 32px;
  margin: 0 8px;
  text-align: center;
  font-size: 16px;
}

.switchableText {
  border: none;
  background: none;
  font-weight: normal;
  font-size: 16px;
  padding: 4px 16px;
  color: var(--neutral-900);
  background: var(--neutral-300);
  border-radius: 24px;
  cursor: pointer;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

#collapse-button {
  background: var(--primary-500);
  color: var(--neutral-100);
  padding: 8px;
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
#collapse-button:hover {
  background: var(--primary-600);
}

@media (min-width: 1140px) {
  .collections {
    grid-template-columns: repeat(auto-fit, 200px);
    grid-auto-rows: 1fr;
    justify-content: center;
  }
  #card-buttons {
    display: flex;
  }
  #card-select {
    display: none;
  }
  #collapse-button {
    display: none;
  }
}

@media (max-width: 1140px) {
  .collections {
    display: flex;
    overflow-x: auto;
    flex-direction: row;
    justify-content: flex-start;
    box-shadow: -45px 0 20px -20px var(--neutral-200) inset;
  }

  .collection {
    font-size: 0.8em;
    flex: 1 1 0px;
    min-width: 128px;
  }

  #edit-grid {
    display: flex;
    flex-direction: column;
  }

  #lower-sidebar {
    max-height: 40vh;
  }

  #card-list {
    max-height: 75%;
  }
  #upload-wrapper,
  .sep {
    display: none;
  }
  #card-buttons {
    display: none;
  }
  #card-select {
    display: block;
  }
}

#card-details {
  margin-top: 18px;
  font-size: 10px;
  color: var(--neutral-700);
}

/* INTRO */

#title-wrapper-collection {
  display: flex;
  gap: 8px;
}

.demo-page {
  max-width: min(95%, 850px);
  width: min(95%, 850px);
  margin: 150px auto;
}

.demo-page .card {
  margin: 18px 0;
}

.premade-card {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  margin: 0 !important;
}

.premade-card img {
  max-height: 250px;
}

.premade-card:hover {
  background: var(--neutral-300);
}

#premade-card-select {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin: 12px auto;
}

/* QUEUE */

#main-row {
  display: flex;
  justify-content: space-around;
  align-items: center;
  justify-self: flex-start;
  flex: 1;
}
.queue-card {
  font-size: 2em;
  flex: 1;
  text-align: center;
  /* border-top: 3px #ffcb64 solid; */
  border: 3px var(--neutral-300) solid;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 32px;
  height: 100%;
  margin: 64px 48px 128px 48px;
  max-width: min(95%, 1000px);
}

.card-correct {
  animation-name: correct-flash;
  animation-duration: 2s;
}

.card-correct #queue-spacer {
  border-color: var(--positive-700);
}

#celebration {
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

@keyframes correct-flash {
  0% {
    border-color: var(--neutral-300);
    color: var(--neutral-900);
    background: var(--neutral-200);
    box-shadow: none;
  }
  10% {
    border-color: var(--positive-500);
    color: var(--positive-700);
    background: rgba(0, 255, 0, 0.1);
    box-shadow: 0 0 32px var(--positive-700);
  }
  100% {
    border-color: var(--neutral-300);
    color: var(--neutral-900);
    background: var(--neutral-200);
    box-shadow: none;
  }
}

#queue-buttons {
  position: sticky;
  background: rgba(250, 250, 250, 0.8);
  bottom: 0;
  width: 100%;
  left: 0;
}

@media (max-width: 600px) {
  .queue-card {
    margin: 8px;
    font-size: 1.2em;
  }

  #queue-buttons {
    position: fixed;
    bottom: 18px;
  }
  #queue-buttons div {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
  }

  .hide-on-mobile {
    display: none;
  }
}

.normal-text {
  font-size: 0.7em;
}

.queue-card img {
  max-height: 60vh;
  max-width: 100%;
  margin: 24px 0;
}

.learn img {
  max-height: 35vh;
}

.queue-card ul,
.queue-card ol {
  text-align: left;
  margin-left: 32px;
}

.queue-card h1,
.queue-card h2,
.queue-card h3,
.queue-card h4,
.queue-card h5,
.queue-card h6 {
  margin: 12px 0;
}

.queue-card p {
  margin: 6px 0;
}

#card-wrapper {
  min-width: min(800px, 95%);
  min-height: min(600px, 65%);
  /* overflow-y: auto; */
  margin: 36px auto;
  display: flex;
  flex-direction: column;
  flex: 1;
}

@media (max-width: 600px) {
  #card-wrapper {
    margin: 0;
  }
}

#back,
#front {
  margin: auto;
}

#queue-spacer {
  border-top: 3px var(--primary-600) dashed;
  margin: 24px 0;
}
.top-row {
  display: flex;
  justify-content: space-between;
  color: var(--neutral-400);
  font-size: 14px;
}

#edit-link {
  color: var(--neutral-500);
  font-size: 14px;
}

#queue-done {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

#card-nav {
  padding: 0 48px;
  display: flex;
  justify-content: space-between;
  opacity: 0.6;
}

#card-nav svg {
  height: 18px;
  width: 18px;
  cursor: pointer;
}

#first-time-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

#queue-again-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

/* QUEUE BUTTON ANIMATION */
.queue-button:disabled {
  cursor: not-allowed;
  animation: enable 3s ease;
}
/* 
.queue-button {
  opacity: 1;
  transition: 0.3s;
} */

@media (max-width: 600px) {
  .button-list {
    flex-direction: column;
    margin: 8px;
    gap: 8px;
  }
}

@keyframes enable {
  0% {
    opacity: 0;
    color: var(--neutral-200);
  }
  90% {
    color: var(--neutral-300);
  }

  100% {
    opacity: 1;
    color: var(--neutral-900);
  }
}

/* LANDING PAGE */

h1 {
  margin-bottom: 8px;
}

#landing-wrapper {
  background-position: right;
  background-size: auto;
  background-repeat: no-repeat;
  padding-right: 180px;
  background-origin: content-box;
  background-image: url("./assets/learn.svg");
}

.big-heading {
  font-size: 3em;
}

.big-text {
  font-size: 1.5em;
  margin-top: 25px;
  max-width: 500px;
  line-height: 1.5em;
}

#landing-content {
  padding: 5%;
  max-width: 650px;
  display: flex;
  flex-direction: column;
  background: rgba(233, 233, 233, 0.8);
  margin-top: 64px;
}

#landing-button {
  margin-top: 32px;
  width: auto;
  display: inline-block;
  font-size: 1.5em;
}

@media (max-width: 600px) {
  #landing-content {
    display: none;
  }

  #landing-content-mobile {
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 100vw;
    margin-bottom: 100px;
  }

  #landing-wrapper {
    background: var(--neutral-100);
  }
}

@media (min-width: 600px) {
  #landing-content-mobile {
    display: none;
  }
}
#hero-img-wrapper {
  max-width: 80%;
}
#hero-img {
  max-width: 100%;
  max-height: 44vh;
}

/* SCORE */

#score-wrapper {
  /* background: #1d1a20; */
  min-width: 100%;
  display: flex;
  justify-content: space-between;
  top: 104px;
  position: fixed;
}

#score {
  /* max-width: 74%; */
  background: var(--primary-500);
  height: 3px;
  flex: 1;
  transition: 0.2s;
}

.info-wrapper {
  display: flex;
  gap: 8px;
  align-items: center;
}

#score-info {
  padding: 2px 8px;
  display: flex;
  gap: 8px;
}

/* AUTH */

.button-secondary {
  flex: 1;
  text-align: right;
}

/*  ERRORS */

#error-message {
  background-color: #700f0f;
  margin-left: auto;
  margin-right: auto;
  border-radius: 8px;
  padding: 8px;
  text-align: center;
  display: flex;
  gap: 16px;
  flex-shrink: 1;
}

#error-wrapper {
  display: flex;
  gap: 8px;
}

.fadeAway-enter-active {
  transition: all 0.3s ease;
}

.fadeAway-leave-active {
  transition: all 0.4s cubic-bezier(1, 0.5, 0.8, 1);
}

.fadeAway-leave-to,
.fadeAway-enter {
  opacity: 0;
  transform: translateX(100px);
}

/* PREVIEW */

.overlay-card {
  position: fixed;
  width: 90vw;
  height: 80vh;
  margin: auto;
  overflow-y: auto;

  border-radius: 64px;
  z-index: 1000;
  transition: 0.3s;
  display: flex;
  top: 10vh;
  left: 5vw;
}
.overlay {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 999;
  transition: 0.3s;
}

#deactivatePreview {
  position: fixed;
  z-index: 1001;
  top: 128px;
  right: 128px;
  height: 64px;
  width: 64px;
  color: var(--primary-500);
}

/* TRANSITIONS */

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease-in-out;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.list-item {
  display: inline-block;
  margin-right: 10px;
}
.list-enter-active,
.list-leave-active {
  transition: all 1s;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}

/* PRICING */

#pricing-wrapper {
  display: flex;
  flex-direction: row;
  margin: auto;
  justify-content: center;
  max-width: min(95%, 800px);
  align-content: center;
}

#pricing-wrapper .card {
  flex: 1;
}

.pricing {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

.pricing .spacer {
  flex: 1;
}

#about {
  margin-top: 24px;
}

#about p,
#about h3 {
  margin: 16px 0;
}

#reset-password-wrapper {
  display: flex;
  flex-direction: row;
  gap: 8px;
}

#reset-password-email {
  flex: 1;
}

/* LANDING */

#product-description {
  width: min(95%, 800px);
  margin: auto;
}

#screenshots-heading {
  margin: 32px 0;
  text-align: center;
}

.screenshot-wrapper {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 48px;
  padding: 64px 16px;
  justify-content: space-around;
  max-width: min(900px, 95%);
  margin: auto;
  align-items: center;
  position: relative;
  border-top: 4px solid var(--neutral-200);
}

.mock {
  border: 8px solid var(--neutral-700);
  box-shadow: 0px 0px 5px var(--neutral-500);
  height: auto;
  min-width: 65%;
  border-radius: 8px;
  box-sizing: border-box;
  flex: 1;
}

/* FLOAT STUFF */
.float {
  position: absolute;
  animation: moveOffScreen ease-in-out forwards;
  box-shadow: 0px 0px 25px var(--neutral-500);
  /* transition all */
  opacity: 0;
  transition: all 0.5s ease-in-out;
}

#notes {
  position: relative;
  min-height: 87vh;
  width: 100vw;
  overflow: hidden;
}

@keyframes moveOffScreen {
  0% {
    transform: translateX(0);
  }
  10% {
    opacity: 1;
  }
  95% {
    opacity: 1;
  }
  100% {
    transform: translateX(100vw);
    opacity: 0;
  }
}

.v-enter-active,
.v-leave-active {
  transition: opacity 1.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

#sticker-wrapper {
  position: absolute;
  left: 64px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  z-index: 2;
}

.icon-button {
  width: 36px;
  height: 36px;
}

.icon-button-wrapper:hover {
  cursor: pointer;
}

.icon-button-sticker {
  font-size: 10px
}

.icon-button-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none !important;
}

.sticker, #active-sticker {
  position: absolute;
  min-width: 60px;
  min-height: 60px;
  font-size: 60px;
}

#active-sticker {
  font-size: 60px;
  min-width: 60px;
  min-height: 60px;
}

#queue-footer {
  background: var(--neutral-200);
  padding: 18px;
}

/* Connect stuff */

.connect-card-tools {
  display: flex;
  justify-content: justify-around;
  background: var(--neutral-200);
  width: 100%;
  border-radius: 8px;
  padding: 8px;
}

.connect-card * {
  max-width: 100%;
}

.link {
  cursor: pointer;
  text-decoration: underline;
}

.textarea-standalone {
  border: 3px var(--neutral-300) solid;
  width: 90%;
  font-size: 1.6rem; 

}

.long-arrow {
  width: 100%;
  /* make 1/10 of height */
  transform: scaleY(0.1);
}

#connection-wrapper {
  flex-wrap: no-wrap;
}

#connection-wrapper > * {
  flex: 1;
}

#connection-message-wrapper {
  max-width: 30%;
}

/* special cursor for disabled buttons */

button:disabled {
cursor: not-allowed;
}

/* define a class to only show an element after 1 second */
@keyframes delay-show {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.delay {
  opacity: 0;
  animation: delay-show 2s forwards 3s;
}


</style>
